export default __webpack_public_path__ + "static/media/banner4.ca3c3270.jpg";